module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/clients/client-list/client-list.component.css
// module id = ./src/app/components/clients/client-list/client-list.component.css
// module chunks = main